import formatDate from "./fomatDate";

function formatDate2(date: any) {
    // formatDate retourne desormais directement "yyyy-MM-ddTHH:mm:ss" (ISO) :
    // plus besoin de reconvertir dd/MM/yyyy ici.
    return formatDate(date);
}

export default formatDate2;
